/*
 * @Description: 超时
 * @Date: 2020-12-12 17:43:20
 */

import fields from './fields';
import { createTotalPayment, reMark } from './fields';

import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import {
  listInvalidPayOrder,
  listBatchInvalidPayOrder,
  orderManagement
} from '@/api/ajax';
import {
  bankRowLabelFiled,
  bankSearchFiled,
  payTypeRowLabelFiled,
  payTypeSearchFiled
} from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';

const rebuild = {
  name: '全部重新生成',
  type: 'primary',
  fn: async (app, table) => {
    if (table.tableData.length) {
      let query = { ...table.searchQuery };
      delete query.pageNo;
      delete query.pageSize;
      await orderManagement.rebuildOrder({
        ...query
      });
      table.$message('全部订单已重新生成');
      table.searchEvent();
    }
  }
};
let example = new TableRenderClass({ fields, search });

const batchPart = example.createPart({
  name: '按生成批次展示',
  search: [
    'orderNo',
    'batchOrderNo',
    'projectName',
    'dingdanshengchengshijian',
    'industrial',
    bankSearchFiled,
    payTypeSearchFiled
  ],
  list: listBatchInvalidPayOrder,
  requestNow: true,
  fields: [
    'index',
    'batchOrderNo',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'daizhifudingdanshengchengshijian',
    createTotalPayment(4),
    'feeType',
    reMark(),
    '_paymentProgress',
    'rebuildOperation'
  ],
  moreBtnArr: [rebuild]
});
const projectPart = example.createPart({
  name: '按项目展示',
  search: [
    'orderNo',
    'batchOrderNo',
    'projectName',
    'dingdanshengchengshijian',
    'zhifujiezhishijian',
    'paymentDeadline',
    'industrialReal',
    bankSearchFiled,
    payTypeSearchFiled
  ],
  list: listInvalidPayOrder,
  requestNow: true,
  fields: [
    'index',
    'orderNo',
    'batchOrderNo',
    'projectName',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'daizhifudingdanshengchengshijian',
    'zhifujiezhishijian',
    'industryName',
    createTotalPayment(4),
    'feeType',
    'remark',
    '_paymentProgress',
    'rebuildOperation'
  ],
  moreBtnArr: [rebuild]
});
export default {
  name: '失效订单',
  childMenu: [projectPart, batchPart]
};
